import { useContext, useState } from "react";
import { Box, Button, Typography, TextField, Grid2, Grid } from "@mui/material";
import { ReactComponent as LoadIcon } from "../../../images/loadExampleButton.svg";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAccordion from "../../custom-components/CommonAccordion";
import SendIcon from "@mui/icons-material/Send";
import { testSummaryReportContext } from "../../main-pages/TestSummaryReportPage";

const Introduction = () => {
  const { Introduction, scope } = useContext(testSummaryReportContext);
  const navigate = useNavigate();
  const [sprintNo, setSprintNo] = useState("");
  const [projectName, setProjectName] = useState("");
  const [description, setDescription] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");

  const isDetailsFilled =
    sprintNo.trim() !== "" &&
    projectName.trim() !== "" &&
    description.trim() !== "" &&
    StartDate.trim() !== "" &&
    EndDate.trim() !== "";

  const handleIntroductionNext = async () => {
    try {
      // Add your logic here
      let introductionData = {
        sprintNo: sprintNo,
        projectName: projectName,
        description: description,
        StartDate: StartDate,
        EndDate: EndDate,
      };
      navigate("/dashboard/sprint-summary-report/output", {
        state: { introductionData: introductionData },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormLoadDemoExample = (e) => {
    e.stopPropagation();
    setSprintNo("Sprint 1");
    setProjectName("Qmentis");
    setDescription("This is a demo example for introduction section.");
    setStartDate("2022-01-01");
    setEndDate("2022-01-31");
  };

  return (
    <CommonAccordion
      summary={
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle1" sx={{ fontSize: "16px" }}>
            Introduction
          </Typography>
          <Button
            variant="text"
            startIcon={<LoadIcon />}
            sx={{
              ml: 2,
              textTransform: "none",
              position: "relative",
              top: "0px",
            }}
            onClick={handleFormLoadDemoExample}
          >
            Load Demo Example
          </Button>
        </Box>
      }
      details={
        <Box sx={{ padding: "24px" }}>
          <Grid container spacing={2}>
            {/* Sprint No */}
            <Grid item xs={5}>
              <TextField
                label="Sprint No."
                fullWidth
                placeholder="Enter Sprint No."
                variant="outlined"
                size="medium"
                value={sprintNo}
                onChange={(e) => setSprintNo(e.target.value)}
              />
            </Grid>

            {/* Project Name */}
            <Grid item xs={7}>
              <TextField
                label="Project Name"
                fullWidth
                placeholder="Enter Project Name"
                variant="outlined"
                size="medium"
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
              />
            </Grid>
          </Grid>

          {/* Sprint Description */}
          <Box sx={{ marginTop: 4 }}>
            <TextField
              label="Sprint Description"
              fullWidth
              placeholder="Enter Description"
              variant="outlined"
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
              mt: 2,
            }}
          >
            {/* Start Date Field */}
            <TextField
              label="Start Date"
              fullWidth
              type="date"
              variant="outlined"
              margin="normal"
              value={StartDate}
              onChange={(e) => setStartDate(e.target.value)}
              placeholder="dd/mm/yyyy"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: "50%" }}
            />

            {/* End Date Field */}
            <TextField
              label="End Date"
              type="date"
              variant="outlined"
              margin="normal"
              value={EndDate}
              onChange={(e) => setEndDate(e.target.value)}
              placeholder="dd/mm/yyyy"
              InputLabelProps2={{
                shrink: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: "50%" }}
              disabled={!StartDate}
            />
          </Box>
        </Box>
      }
      buttons={[
        {
          label: "Next",
          variant: "contained",
          startIcon: <SendIcon />,
          onClick: handleIntroductionNext,

          sx: {
            float: "right",
            textTransform: "none",
            backgroundColor: isDetailsFilled ? "#49A3FF" : "grey",
            color: isDetailsFilled ? "white" : "black",
            "&:hover": {
              backgroundColor: isDetailsFilled ? "#49A3FF" : "darkgrey",
            },
          },
          disabled: !isDetailsFilled,
        },
      ]}
      type="input"
      defaultExpanded={true}
    />
  );
};

export default Introduction;
